<div class="d-flex position-relative">
  <app-top-bar />
  <div class="sidebar">
    <img src="logo.svg" alt="" class="logo" />
    <nav class="sidebar-menu">
      @for (item of menuItems(); track item; let i = $index) {
        @if (item.externalUrl) {
          <div class="menu-item">
            <a
              class="menu-item-header collapsed"
              [href]="item.externalUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img [src]="item.iconSrc" alt="" class="menu-item-icon" />
              <span class="menu-item-label">{{ item.label }}</span>
            </a>
          </div>
        } @else {
          <div class="menu-item">
            <button
              class="menu-item-header"
              [class.collapsed]="!item.expanded"
              (click)="toggleExpanded(item)"
              [attr.aria-expanded]="item.expanded"
              [attr.aria-controls]="'menu-children-' + i"
            >
              @if (item.icon) {
                <span class="material-symbols-outlined">{{ item.icon }}</span>
              }
              <span class="menu-item-label">{{ item.label }}</span>
              <span class="material-symbols-outlined menu-item-arrow">arrow_drop_up</span>
            </button>

            <ul
              class="menu-item-list list-unstyled mb-0 collapse"
              [class.show]="item.expanded"
              [id]="'menu-children-' + i"
            >
              @for (child of item.children; track child) {
                @if (child.children?.length) {
                  <li>
                    <button
                      class="menu-item-link"
                      [class.collapsed]="!child.expanded"
                      (click)="toggleExpanded(child)"
                      [attr.aria-expanded]="child.expanded"
                      [attr.aria-controls]="collapseId(child.label, 'menu-children-' + i)"
                    >
                      {{ child.label }}
                      <span class="material-symbols-outlined menu-item-arrow">arrow_drop_up</span>
                    </button>

                    <ul
                      class="menu-item-list menu-item-list-nested list-unstyled mb-0 collapse"
                      [class.show]="child.expanded"
                      [id]="collapseId(child.label, 'menu-children-' + i)"
                    >
                      @for (grandchild of child.children; track grandchild) {
                        <li>
                          <a
                            class="menu-item-link menu-item-link-nested"
                            [class.active]="isChildActive(grandchild.route!)"
                            [routerLink]="grandchild.route"
                          >
                            {{ grandchild.label }}
                          </a>
                        </li>
                      }
                    </ul>
                  </li>
                } @else {
                  <li>
                    <a
                      class="menu-item-link"
                      [class.active]="isChildActive(child.route!)"
                      [routerLink]="child.route"
                    >
                      {{ child.label }}
                    </a>
                  </li>
                }
              }
            </ul>
          </div>
        }
      }
    </nav>
  </div>

  <main class="flex-grow-1 pt-10">
    @if (showGoBack()) {
      <a href="" (click)="goBack($event)" class="text-secondary">
        <span class="material-symbols-outlined align-middle me-2">keyboard_arrow_left</span>
        Volver atrás
      </a>
    }
    <div
      class="d-flex justify-content-between align-items-center mb-4"
      [class]="showGoBack() ? 'mt-6' : 'mt-8'"
    >
      <div>
        <h1 class="h5 fw-bold text-secondary mb-0">{{ title() }}</h1>
        @if (subtitle()) {
          <p class="small text-muted mb-0 mt-1">{{ subtitle() }}</p>
        }
      </div>
      @if (actions()?.length) {
        <div class="d-flex gap-2">
          @for (action of actions(); track $index) {
            <app-button
              [text]="action.label"
              size="sm"
              [icon]="action.icon"
              [variant]="action.variant ?? 'filled'"
              [color]="action.color ?? 'primary'"
              [attr.data-bs-toggle]="action.toggleType"
              [attr.data-bs-target]="'#' + action.targetId"
              [href]="action.url"
              [variant]="action.variant || 'filled'"
              [color]="action.color || 'primary'"
            />
          }
        </div>
      }
    </div>
    <router-outlet />
  </main>
</div>
